import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import Footer from "./Footer";

const Cart = () => {
  const { cart, removeFromCart, updateQuantity, billing } = useContext(CartContext);
  const navigate = useNavigate();

  return (
    <div className="bg-grey min-h-screen text-white p-4 md:p-6">
      {/* Cart Table */}
      <div className="w-full max-w-6xl mx-auto bg-grey text-white">
        <div className="hidden md:grid grid-cols-4 bg-orange text-white font-bold py-3 px-4">
          <p>Product</p>
          <p>Price</p>
          <p>Quantity</p>
          <p>Subtotal</p>
        </div>

        {cart.length === 0 ? (
          <div className="text-center py-6 text-lg">
            <p>Your cart is empty.</p>
            <button
              onClick={() => navigate("/collection")}
              className="mt-4 bg-orange text-white px-4 py-2 rounded-md"
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          cart.map((item) => (
            <div
              key={item.id}
              className="flex flex-col md:grid md:grid-cols-4 items-center py-4 px-4 border-b border-gray-700 gap-4"
            >
              <div className="flex items-center gap-4 w-full md:w-auto">
                <img src={item.image} alt={item.name} className="w-16 h-16 rounded-md object-cover" />
                <p className="text-sm md:text-base">{item.name}</p>
              </div>
              <p className="text-sm md:text-base">₦{item.price.toLocaleString()}</p>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  min="1"
                  value={item.quantity}
                  onChange={(e) =>
                    updateQuantity(item.id, Math.max(1, parseInt(e.target.value) || 1))
                  }
                  className="w-12 text-center bg-black border border-gray-600 rounded-md"
                />
              </div>
              <div className="flex justify-between items-center w-full md:w-auto">
                <p className="text-sm md:text-base">N{(item.price * item.quantity).toLocaleString()}</p>
                <button onClick={() => removeFromCart(item.id)} className="text-gray-400 hover:text-red-500">
                  🗑️
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Cart Totals */}
      {/* Cart Totals */}
      {cart.length > 0 && (
        <div className="flex justify-center mt-6">
          <div className="bg-orange-500 text-white p-6 w-full max-w-sm rounded-md">
            <h2 className="text-xl font-bold mb-4 text-center">Cart Totals</h2>
            <div className="flex justify-between text-lg">
              <p>Subtotal</p>
              <p>₦{billing.total ? billing.total.toLocaleString() : "0"}</p>
            </div>
            <div className="flex justify-between font-bold text-xl mt-2">
              <p>Total</p>
              <p>₦{billing.total ? billing.total.toLocaleString() : "0"}</p>
            </div>
            <button
              className="mt-4 w-full bg-orange text-white py-3 rounded-md"
              onClick={() => navigate("/checkout")}
            >
              Check Out
            </button>
          </div>
        </div>
      )}


      <Footer />
    </div>
  );
};

export default Cart;
